import type { AnniversarySDate } from "../../person/types";

export enum NoteStatuses {
  TO_DO = "TO_DO",
  IN_PROGRESS = "IN_PROGRESS",
  DONE = "DONE",
}

export enum EventTypes {
  NOTE = "note",
  BIRTHDAY = "birthday",
  ANNIVERSARY = "anniversary",
}

export type AnniversaryEvent = {
  type: EventTypes.ANNIVERSARY;
  date: AnniversarySDate;
  description: string;
  personId: string;
  firstName: string;
  lastName: string;
};

export type BirthdayEvent = Omit<AnniversaryEvent, "type"> & {
  type: EventTypes.BIRTHDAY;
};

export type NoteEvent = {
  type: EventTypes.NOTE;
  description: string;
  personId: string;
  noteId: string;
  firstName: string;
  lastName: string;
  title: string;
  date: string;
  important: boolean;
  status: NoteStatuses;
};

export type CalendarControllerResponse = {
  birthdays: BirthdayEvent[];
  anniversaries: AnniversaryEvent[];
  notes: NoteEvent[];
};

export type CalendarControllerPayload = {
  fromDate: string;
  toDate: string;
};
